import * as React from 'react';
import clsx from 'clsx';
import { Button } from '@/components/ui/Button';

interface SearchWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SearchWarningModal: React.FC<SearchWarningModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 z-modal flex items-center justify-center p-4'>
      <div className='absolute inset-0 bg-black/40 backdrop-blur-sm' onClick={onClose} />
      <div
        className={clsx(
          'relative flex w-full max-w-[440px] flex-col items-center gap-6 p-8',
          'max-h-[90vh] overflow-y-auto',
          'rounded-20 border-4 border-brand-800 bg-white shadow-2xl'
        )}
      >
        <h3 className='font-sans text-20 font-bold text-brand-800'>Activate Internet Search</h3>
        <p className='text-center font-sans text-16 font-normal leading-24 text-gray-530'>
          Please activate either Free or Premium internet search before starting training. This
          helps us collect data to build your echo&apos;s personality.
        </p>
        <Button
          variant='purple-dark'
          className='h-[44px] w-[180px] text-16 font-bold uppercase tracking-wide'
          onClick={onClose}
        >
          GOT IT
        </Button>
      </div>
    </div>
  );
};
